import { Colors } from "@jsq/ds/styles";
import { PaymentStatus } from "../../../graphql/supergraph.index";
import { PaymentStatus as PaymentStatusEnum } from "../../../graphql/supergraphOperations";
import { TextWithIconProps } from "../../TextWithIcon";
import { PaymentType } from "../types";

export enum PaymentStatusForUI {
  NotTransmitted = "Not yet transmitted",
  Processing = "Processing",
  Completed = "Completed",
  Failed = "Failed",
  Canceled = "Canceled",
}

/**
 * Map of payment status filters
 * This map is prepared to be used in the filter dropdown. The key's will be provided as the filter options and
 * the corresponding values would be used to sent it to the API for the server side filtering
 */
export const paymentStatusFilterTypes: Map<string, PaymentStatus[]> = new Map([
  [PaymentStatusForUI.NotTransmitted, [PaymentStatusEnum.Pending]],
  [PaymentStatusForUI.Processing, [PaymentStatusEnum.Processing]],
  [PaymentStatusForUI.Completed, [PaymentStatusEnum.Settled]],
  [PaymentStatusForUI.Failed, [PaymentStatusEnum.Failed]],
  [PaymentStatusForUI.Canceled, [PaymentStatusEnum.Canceled]],
]);

/**
 * Provides the data to be displayed with respect to each payment status
 * @param payments
 * @returns
 */
export const paymentStatusUIConfig = (payments: PaymentType[]): TextWithIconProps[] => {
  const statusMap = payments.reduce((acc: Map<PaymentStatus, number>, payment: PaymentType) => {
    acc.set(payment.status, (acc.get(payment.status) || 0) + 1);
    return acc;
  }, new Map<PaymentStatus, number>());

  let paymentCount = statusMap.get(PaymentStatusEnum.Pending) ?? 0;
  if (paymentCount > 0) {
    return [
      {
        label: `${paymentCount} ${PaymentStatusForUI.NotTransmitted}`,
        iconType: "hourglass-start",
        iconColor: Colors.Neutral800,
      },
    ];
  } else {
    const paymentStatusConfig: TextWithIconProps[] = [];
    [...statusMap].map((item) => {
      paymentCount = item[1];
      switch (item[0]) {
        case PaymentStatusEnum.Processing:
          paymentStatusConfig.push({
            label: `${paymentCount} ${PaymentStatusForUI.Processing}`,
            iconType: "sync-alt",
            iconColor: Colors.Neutral800,
          });
          break;
        case PaymentStatusEnum.Settled:
          paymentStatusConfig.push({
            label: `${paymentCount} ${PaymentStatusForUI.Completed}`,
            iconType: "check",
            iconColor: Colors.Success600,
          });
          break;
        case PaymentStatusEnum.Failed:
          paymentStatusConfig.push({
            label: `${paymentCount} ${PaymentStatusForUI.Failed}`,
            iconType: "exclamation-circle",
            iconColor: Colors.Danger600,
          });
          break;
        case PaymentStatusEnum.Canceled:
          paymentStatusConfig.push({
            label: `${paymentCount} ${PaymentStatusForUI.Canceled}`,
            iconType: "exclamation-circle",
            iconColor: Colors.Danger600,
          });
      }
    });
    return paymentStatusConfig;
  }
};

/**
 * Parses the payment status filter values to the API compatible format
 * @param filteredValues user selected filter values
 * @returns
 */
export const parseStatusFilter = (filteredValues: Array<PaymentStatusForUI>) => {
  return filteredValues.reduce((acc: PaymentStatus[], item) => {
    const status = paymentStatusFilterTypes.get(item);
    if (status) {
      acc = acc.concat(status);
    }
    return acc;
  }, []);
};
